// Accordion Component JavaScript
// This code can be copied for use in Drupal/WordPress

export function initAccordion() {
	// Respect prefers-reduced-motion
	const prefersReducedMotion = window.matchMedia(
		"(prefers-reduced-motion: reduce)",
	).matches;

	if (prefersReducedMotion) {
		const icons = document.querySelectorAll(".accordion-icon");
		icons.forEach((icon) => {
			icon.style.transition = "none";
		});
	}
}

// Auto-initialize if DOM is ready
if (typeof document !== "undefined") {
	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", initAccordion);
	} else {
		initAccordion();
	}
}

